import React from 'react'

export default function PlusSvg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={15}
            height={15}
            viewBox="0 0 32 32"
        >
            <title>{"plus"}</title>
            <path
                fill="#000"
                fillRule="evenodd"
                d="M28 12h-8V4a4 4 0 1 0-8 0v8H4a4 4 0 1 0 0 8h8v8a4 4 0 1 0 8 0v-8h8a4 4 0 1 0 0-8"
            />
        </svg>
    )
}
